var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import qs from "qs";
import { useEffect } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import makeGlobal from "../utils/makeGlobal";
// function extractNodes<T>(response: ApiList<T>) {
//   return response.edges.map(e => e.node)
// }
// export function makeUseInfinitList<T>(fetcher: Fetcher<T>) {
//   const initialState: ListState<T> = {
//     tag: 'empty',
//     loading: false
//   }
//
//   const mapStateFetchMore = (
//     state: ListState<T>,
//     list: ApiList<T>
//   ): ListState<T> => {
//     switch (state.tag) {
//       case 'error':
//       case 'empty':
//         return {
//           tag: 'with-data',
//           loading: false,
//           list: extractNodes(list),
//           totalCount: list.totalCount,
//           page: 0,
//           hasMore: extractNodes(list).length > 0
//         }
//       case 'with-data':
//         return {
//           tag: 'with-data',
//           loading: false,
//           list: state.list.concat(extractNodes(list)),
//           totalCount: list.totalCount,
//           page: 0,
//           hasMore: extractNodes(list).length > 0
//         }
//     }
//   }
//
//   const actions: StoreActions<ListState<T>, InfinitListActions<T>> = {
//     fetchMore: store => fetcher => async params => {
//       const response = await fetcher.findAll(params)
//       if (response.ok) {
//         store.setState({
//           tag: 'with-data',
//           list: response.data?.edges.map(e => e.node) ?? [],
//           totalCount: response.data?.totalCount ?? 0,
//           loading: false,
//           // page: params.page,
//           page: 0,
//           hasMore: true
//         })
//       }
//     }
//   }
// }
export function makeUseList(fetch) {
    var _this = this;
    var initialState = {
        tag: "empty",
        loading: false,
    };
    var actions = {
        fetchPage: function (store) { return function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (store.state.tag === "error") {
                            store.setState({ tag: "empty", loading: true });
                        }
                        else {
                            store.setState(__assign(__assign({}, store.state), { loading: true }));
                        }
                        return [4 /*yield*/, fetch(params)];
                    case 1:
                        response = _f.sent();
                        if (response.ok) {
                            store.setState({
                                tag: "with-data",
                                list: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.edges.map(function (e) { return e.node; })) !== null && _b !== void 0 ? _b : [],
                                totalCount: (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.totalCount) !== null && _d !== void 0 ? _d : 0,
                                loading: false,
                                page: Number((_e = params === null || params === void 0 ? void 0 : params.page) !== null && _e !== void 0 ? _e : 1),
                                hasMore: true,
                            });
                        }
                        else {
                            store.setState({
                                tag: "error",
                                error: String(response.problem),
                                status: response.status,
                                data: response.data
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); }; },
        reset: function (store) { return function () {
            store.setState(initialState);
        }; },
    };
    var useListState = makeGlobal(initialState, actions);
    var useList = function () {
        var _a = useListState(), state = _a[0], actions = _a[1];
        var location = useLocation();
        var fetchPage = function () {
            actions.fetchPage(qs.parse(location.search.substring(1)));
        };
        useEffect(function () {
            fetchPage();
            return actions.reset;
        }, [location.search]);
        return [state, { fetchPage: fetchPage }];
    };
    return useList;
}
export function makeUseListSubRepository(fetch) {
    var _this = this;
    var initialState = {
        tag: "empty",
        loading: false,
    };
    var actions = {
        fetchPage: function (store) { return function (parentId, params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (store.state.tag === "error") {
                            store.setState({ tag: "empty", loading: true });
                        }
                        else {
                            store.setState(__assign(__assign({}, store.state), { loading: true }));
                        }
                        return [4 /*yield*/, fetch(parentId, params)];
                    case 1:
                        response = _f.sent();
                        if (response.ok) {
                            store.setState({
                                tag: "with-data",
                                list: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.edges.map(function (e) { return e.node; })) !== null && _b !== void 0 ? _b : [],
                                totalCount: (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.totalCount) !== null && _d !== void 0 ? _d : 0,
                                loading: false,
                                page: Number((_e = params === null || params === void 0 ? void 0 : params.page) !== null && _e !== void 0 ? _e : 1),
                                hasMore: true,
                            });
                        }
                        else {
                            store.setState({
                                tag: "error",
                                error: String(response.problem),
                                status: response.status,
                                data: response.data
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); }; },
    };
    var useGlobal = makeGlobal(initialState, actions);
    var useList = function () {
        var _a = useGlobal(), state = _a[0], actions = _a[1];
        var location = useLocation();
        var match = useRouteMatch();
        var fetchPage = function () {
            actions.fetchPage(match.params.id, qs.parse(location.search.substring(1)));
        };
        useEffect(function () {
            fetchPage();
        }, [location.search]);
        return [state, { fetchPage: fetchPage }];
    };
    return useList;
}
//# sourceMappingURL=makeUseList.js.map